import React from "react";

const PageHeader = ({ title, subtitle, action, breadcrumb }) => (
  <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-6 pb-4 border-b border-gray-200 dark:border-white/5">
    <div>
      {breadcrumb && (
        <div className="text-xs text-purple-600 dark:text-purple-400 font-semibold mb-1 tracking-wide uppercase">
          {breadcrumb}
        </div>
      )}
      <h1 className="text-2xl sm:text-3xl font-extrabold text-gray-900 dark:text-white tracking-tight">
        {title}
      </h1>
      {subtitle && (
        <p className="text-sm text-gray-600 dark:text-gray-400 mt-1 font-medium">
          {subtitle}
        </p>
      )}
    </div>
    {action && <div className="flex items-center gap-3">{action}</div>}
  </div>
);

export default PageHeader;
